export default {
    TEST: {
        memberLevelSeatNumbers: {
            92: 6,
            93: 10,
            95: 1,
        },
        IndividualMembershipLevelId: 95,
        IndividualConstituentTypeId: 1,
        IndividualOriginalSourceId: 1,
        IndividualAddressTypeId: 3,
        OrganizationConstituentTypeId: 11,
        OrganizationOriginalSourceId: 9,
        OrganizationAddressTypeId: 3,
        OrganizationElectronicAddressTypeId: 1,
        OrganizationPhoneTypeId: 3,
        UserSeatMembershipOrganizationBenefitId: 6,
        AdminSeatMembershipOrganizationBenefitId: 7,
        MembershipOrganizationId: 11,
        TeacherAffiliationTypeId: 10047,
        UserAffiliationTypeId: 10052,
        AdminAffiliationTypeId: 10053,
        FundId: 93,
        EmailDomainAttributeId: 671,
    },
    PROD: {
        memberLevelSeatNumbers: {
            93: 6,
            94: 10,
            92: 1,
        },
        IndividualMembershipLevelId: 92,
        IndividualConstituentTypeId: 1,
        IndividualOriginalSourceId: 1,
        IndividualAddressTypeId: 3,
        OrganizationConstituentTypeId: 11,
        OrganizationOriginalSourceId: 37,
        OrganizationAddressTypeId: 3,
        OrganizationElectronicAddressTypeId: 1,
        OrganizationPhoneTypeId: 3,
        UserSeatMembershipOrganizationBenefitId: 12,
        AdminSeatMembershipOrganizationBenefitId: 13,
        MembershipOrganizationId: 11,
        TeacherAffiliationTypeId: 10047,
        UserAffiliationTypeId: 10052,
        AdminAffiliationTypeId: 10053,
        FundId: 96,
        EmailDomainAttributeId: 681,
    }
}